import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play, Volume2 } from 'lucide-react';
interface Props {
  onNext: () => void;
}
export const Screen6Video = ({
  onNext
}: Props) => {
  return <div className="relative w-full h-full bg-black overflow-hidden" data-id="element-400">
      {/* Background Video */}
      <div className="absolute inset-0" data-id="element-401">
        <video src="https://cdn.magicpatterns.com/uploads/fUgS4zNXWYErDfJ8PBrWX3/women.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-402" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/95" data-id="element-403" />

      {/* Top bar */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-8 left-8 right-8 flex items-center justify-between" data-id="element-404">
        <span className="text-[10px] tracking-[0.3em] uppercase text-white/90 font-semibold" data-id="element-405">
          06 — Voices
        </span>
        <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md rounded-full px-3 py-1 border border-white/10" data-id="element-406">
          <Volume2 className="w-3 h-3 text-white" data-id="element-407" />
          <span className="text-[10px] text-white font-medium" data-id="element-408">Live clip</span>
        </div>
      </motion.div>

      {/* Quote */}
      <div className="absolute inset-x-8 bottom-32 flex flex-col" data-id="element-409">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.7
      }} data-id="element-410">
          <span className="text-xs uppercase tracking-[0.25em] text-red-400 font-semibold mb-3 block" data-id="element-411">
            Question
          </span>
          <h2 className="text-2xl font-bold text-white leading-tight mb-5" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.6)'
        }} data-id="element-412">
            “What gives you confidence right now?”
          </h2>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/10" data-id="element-413">
            <div className="flex items-center space-x-3" data-id="element-414">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center text-white font-bold text-sm" data-id="element-415">
                S
              </div>
              <div data-id="element-416">
                <p className="text-sm text-white font-semibold" data-id="element-417">
                  Sheryl, Leadership
                </p>
                <p className="text-xs text-slate-300" data-id="element-418">Global · 0:47</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* CTA */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1.2
    }} className="absolute bottom-10 left-8 right-8" data-id="element-419">
        <button onClick={onNext} className="w-full bg-white/10 backdrop-blur-md hover:bg-white/15 border border-white/20 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-420">
          <span data-id="element-421">Add your voice</span>
          <ArrowRight className="w-5 h-5" data-id="element-422" />
        </button>
      </motion.div>
    </div>;
};